import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { StreamType } from '../types';
import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export const STREAM__WITH_CURSOR__INITIALIZE = `${actionKey}__INITIALIZE`;
export const STREAM__WITH_CURSOR__SET_CURSOR = `${actionKey}__SET_CURSOR`;
export const STREAM__WITH_CURSOR__FETCH = `${actionKey}__FETCH`;
export const STREAM__WITH_CURSOR__FETCH_SUCCESS = `${actionKey}__FETCH_SUCCESS`;
export const STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE = `${actionKey}__FETCH_SUCCESS_DEDUPE`;
export const STREAM__WITH_CURSOR__INSERT_ITEMS = `${actionKey}__INSERT_ITEMS`;
export const initialize = (_param)=>{
    var { cursor, prevCursor } = _param, baseInitializeParams = _object_without_properties(_param, [
        "cursor",
        "prevCursor"
    ]);
    return _object_spread_props(_object_spread({}, baseInitializeParams), {
        type: STREAM__WITH_CURSOR__INITIALIZE,
        streamType: StreamType.WITH_CURSOR,
        cursor,
        prevCursor
    });
};
export const setCursor = (streamId, cursor)=>({
        type: STREAM__WITH_CURSOR__SET_CURSOR,
        streamId,
        cursor
    });
export const fetch = (streamId)=>({
        type: STREAM__WITH_CURSOR__FETCH,
        streamId
    });
export const fetchAll = (streamId)=>({
        type: STREAM__WITH_CURSOR__FETCH,
        streamId,
        all: true
    });
export const fetchSuccess = ({ streamId, items, entities, hasMore, hasLess, total, cursor, prevCursor })=>({
        type: STREAM__WITH_CURSOR__FETCH_SUCCESS,
        streamId,
        items,
        entities,
        hasMore,
        hasLess,
        total,
        cursor,
        prevCursor
    });
export const fetchSuccessDeduped = (payload)=>_object_spread({
        type: STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE
    }, payload);
export const insertItemsAtOffsetAndSetCursor = ({ streamId, items, offset, entities, newCursor })=>({
        type: STREAM__WITH_CURSOR__INSERT_ITEMS,
        streamId,
        items,
        offset,
        entities,
        newCursor
    });
export const fetchPrevious = createAction(`${actionKey}__FETCH_PREVIOUS`, (streamId)=>({
        streamId
    }));
export const fetchPreviousSuccess = createAction(`${actionKey}__FETCH_PREVIOUS_SUCCESS`, ({ streamId, items, entities, hasLess, prevCursor, dedupeFunction })=>({
        streamId,
        items,
        entities,
        hasLess,
        prevCursor,
        dedupeFunction
    }));
export const fetchAllSuccess = createAction(`${actionKey}__FETCH_All_SUCCESS`, ({ streamId, items, entities })=>({
        streamId,
        items,
        entities
    }));
export const emptyStream = createAction(`${actionKey}__EMPTY`, (streamId)=>({
        streamId
    }));
export const resetStream = createAction(`${actionKey}__RESET`, (streamId)=>({
        streamId
    }));
export { deleteItems, deleteStream, fetchFailure, replaceItem, markAsFetching } from '../base/actions';

//# sourceMappingURL=actions.js.map